import { tns } from './../../../node_modules/tiny-slider/src/tiny-slider';

export default class TemplateGalerie {
  constructor() {
    // Template galerie
    this.galerie();
  }

  galerie() {
    const galeries = document.querySelectorAll('.galerie-item');
    if(galeries.length > 0) {
      galeries.forEach((container) => {
        tns({
          container: container.querySelector('.galerie-sliderWrapper'),
          slideBy: 'page',
          items: 1,
          autoplay: false,
          loop: false,
          mouseDrag: true,
          navPosition: 'bottom',
          controlsText: [
            '<span class="sr-only">Précédent</span><svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13"><path d="M14.592,10.158a.605.605,0,0,1,.853,0l2.981,2.991a.6.6,0,0,1,.019.831l-2.937,2.947a.6.6,0,1,1-.853-.85l2.5-2.534-2.559-2.534A.6.6,0,0,1,14.592,10.158Z" transform="translate(-9.508 -7.046)" fill="#D72677"/><path d="M3.375,9.875a6.5,6.5,0,1,0,6.5-6.5A6.5,6.5,0,0,0,3.375,9.875Zm1,0a5.505,5.505,0,1,1,1.613,3.888A5.453,5.453,0,0,1,4.375,9.875Z"transform="translate(-3.375 -3.375)" fill="#D72677"/></svg>',
            '<span class="sr-only">Suivant</span><svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13"><path d="M14.592,10.158a.605.605,0,0,1,.853,0l2.981,2.991a.6.6,0,0,1,.019.831l-2.937,2.947a.6.6,0,1,1-.853-.85l2.5-2.534-2.559-2.534A.6.6,0,0,1,14.592,10.158Z" transform="translate(-9.508 -7.046)" fill="#D72677"/><path d="M3.375,9.875a6.5,6.5,0,1,0,6.5-6.5A6.5,6.5,0,0,0,3.375,9.875Zm1,0a5.505,5.505,0,1,1,1.613,3.888A5.453,5.453,0,0,1,4.375,9.875Z"transform="translate(-3.375 -3.375)" fill="#D72677"/></svg>',
          ],
        });

        container.querySelector('.galerie-content').addEventListener('click', (e) => {
          e.preventDefault();
          container.querySelector('.galerie-slider').classList.add('js-visible');
        });

        container.querySelector('.galerie-sliderClose').addEventListener('click', (e) => {
          e.preventDefault();
          container.querySelector('.galerie-slider').classList.remove('js-visible');
        });
      });
    }
  }
}